import { Plus } from "@untitledui/icons"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

import {
  ASSESSOR_VIEW_TOGGLE,
  DEBUG_EVENTS_TOGGLE,
  DevToggle,
} from "./dev-toggle"

/**
 * Chat-specific dev tools controls for the sidebar.
 * Only visible on the chat page. Debug Events + Assessor View are admin-gated
 * dev toggles (same flags the replay surface uses).
 */
export function ChatDevTools() {
  const startNewChatConversation = () => {
    if (typeof window === "undefined") return
    try {
      window.dispatchEvent(new CustomEvent("npc-new-conversation"))
    } catch {
      /* ignored: best-effort notification, safe to skip if CustomEvent is unavailable */
    }
  }

  return (
    <SidebarGroup className="px-2 pb-1">
      <SidebarGroupLabel>Chat Dev Tools</SidebarGroupLabel>
      <SidebarMenu>
        <DevToggle spec={DEBUG_EVENTS_TOGGLE} />
        <DevToggle spec={ASSESSOR_VIEW_TOGGLE} />
        <SidebarMenuItem>
          <SidebarMenuButton
            onClick={startNewChatConversation}
            className="cursor-pointer"
          >
            <Plus />
            <span>New Conversation</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
}
